import React from "react"
import Components from "../index"
import { blokType, sbAssetType } from "../../types"
import {
  StyledSection,
  StyledSectionContainer,
  StyledSectionTitle,
  StyledSectionHeader,
  StyledSectionHeading,
  StyledSectionDescription,
  StyledSectionBody,
} from "./partials"

export interface SectionProps {
  icon: sbAssetType
  id: string
  title: string
  description: string
  body: blokType[]
  background_color: string
  custom_id: string
  microdata: boolean
}

export const SectionCmp: React.FC<SectionProps> = ({
  icon,
  id,
  title,
  description,
  body,
  background_color,
  custom_id,
  microdata,
}) => {
  return (
    <StyledSection
      itemScope
      itemType={microdata ? "https://schema.org/FAQPage" : undefined}
      id={custom_id ? custom_id : id}
      background_color={background_color}
    >
      <StyledSectionContainer>
        <StyledSectionHeader>
          {title && (
            <StyledSectionTitle>
              {icon.filename && <img src={icon.filename} />}
              <StyledSectionHeading>{title}</StyledSectionHeading>
            </StyledSectionTitle>
          )}
          {description && (
            <StyledSectionDescription>{description}</StyledSectionDescription>
          )}
        </StyledSectionHeader>

        {body.length > 0 && (
          <StyledSectionBody>
            {body.map((content: blokType) =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
                microdata: microdata,
              })
            )}
          </StyledSectionBody>
        )}
      </StyledSectionContainer>
    </StyledSection>
  )
}
